var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBalcony = function SvgBalcony(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.409 4.409A2.25 2.25 0 0 1 11 3.75h18A2.25 2.25 0 0 1 31.25 6v10.667a1.25 1.25 0 0 1-2.5 0V6.25h-17.5v10.417a1.25 1.25 0 0 1-2.5 0V6c0-.597.237-1.169.659-1.591M2.083 21.667c0-.69.56-1.25 1.25-1.25h33.334a1.25 1.25 0 1 1 0 2.5h-2.084V33.75h2.084a1.25 1.25 0 1 1 0 2.5H3.333a1.25 1.25 0 1 1 0-2.5h2.084V22.917H3.333c-.69 0-1.25-.56-1.25-1.25m5.834 1.25V33.75h4.166V22.917zm6.666 0V33.75h4.167V22.917zm6.667 0V33.75h4.167V22.917zm6.667 0V33.75h4.166V22.917z",
    clipRule: "evenodd"
  })));
};
export default SvgBalcony;